// Typed client over the utoipa-generated OpenAPI spec (SAFE-316).
//
// Paths and payloads type-check against `api-types.ts`, which is generated
// by `npm run gen:openapi`. New code goes through this client; the legacy
// hand-typed `lib/api.ts` shrinks away as old pages are rebuilt
// (SAFE-321…327).
import createClient from 'openapi-fetch';
import type { components, paths } from './types';

export const client = createClient<paths>({ credentials: 'include' });

export type SiteResponse = components['schemas']['SiteResponse'];
export type PortfolioWithLocations =
  components['schemas']['PortfolioWithLocations'];
export type UserSiteRole = components['schemas']['UserSiteRole'];

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

// The Rust backend serializes errors as `{ error: { code, message } }`
// (see ErrorResponse in src/error.rs), so openapi-fetch hands us an object,
// not a string. Dig out the human-readable message, tolerating a bare string
// or a missing body.
function errorMessage(error: unknown, response: Response): string {
  if (typeof error === 'string' && error) return error;
  if (error && typeof error === 'object') {
    const detail = (error as { error?: unknown }).error;
    if (typeof detail === 'string' && detail) return detail;
    if (detail && typeof detail === 'object') {
      const message = (detail as { message?: unknown }).message;
      if (typeof message === 'string' && message) return message;
    }
  }
  return response.statusText;
}

// openapi-fetch returns `{ data, error, response }`; SWR and event handlers
// want resolve-or-throw.
export async function unwrap<T>(
  result: Promise<{ data?: T; error?: unknown; response: Response }>,
): Promise<T> {
  const { data, error, response } = await result;
  if (error !== undefined || !response.ok) {
    throw new ApiError(response.status, errorMessage(error, response));
  }
  return data as T;
}
